<template>
  <div v-if="!listPage" class="empty-list" :style="`height: ${height};`">
    <div class="empty-list__icon">
      <img :src="$vuetify.theme.dark ? emptyListDarkImg : emptyListLightImg" />
    </div>
    <div class="empty-list__title">{{ title }}</div>
    <div class="empty-list__subtitle">{{ subtitle }}</div>
    <div class="empty-list__create">
      <slot name="create">
        <v-btn color="primary" class="left-icon" outlined :to="route">
          <plus-icon class="fill--primary mr-2"></plus-icon>
          {{ $t("custom.empty_list.create") }}
        </v-btn>
      </slot>
    </div>
  </div>

  <div v-else class="empty-list empty-list--big">
    <div class="d-flex w-full justify-space-between">
      <div class="d-flex flex-column justify-center empty-list--big__text-block" :style="`max-width: ${maxWidth}`">
        <div class="empty-list__title">{{ title }}</div>
        <div class="empty-list__subtitle">
          <slot name="subtitle"></slot>
          {{ subtitle }}
        </div>
        <div class="empty-list__create">
          <v-btn color="primary" class="left-icon" :to="route">
            <plus-icon class="mr-2"></plus-icon>
            {{ $t("custom.empty_list.create") }}
          </v-btn>
        </div>
      </div>

      <div class="d-flex flex-column">
        <img :src="$vuetify.theme.dark ? darkImage : lightImage" />
      </div>
    </div>
  </div>
</template>

<script>
  import emptyListLightImg from "@/assets/images/empty-list/generic-empty-list-light.png";
  import emptyListDarkImg from "@/assets/images/empty-list/generic-empty-list-dark.png";

  import emptyListLightBigImg from "@/assets/images/empty-list/page-empty-list-light.svg";
  import emptyListDarkBigImg from "@/assets/images/empty-list/page-empty-list-dark.svg";

  import PlusIcon from "@/components/icons/PlusIcon";

  export default {
    name: "EmptyList",
    components: {
      PlusIcon,
    },
    props: {
      title: {
        type: String,
        default: "",
      },
      subtitle: {
        type: String,
        default: "",
      },
      route: {
        type: Object,
        default: () => {},
      },
      /**
       * If there are multiple empty lists present in a single page, the height of a single empty list should be 300px.
       * If there is only one empty list in a single page, then the height should be 450px;
       */
      height: {
        type: String,
        default: "450px",
      },
      /**
       * Different UI for when the empty resource list is displayed inside a resource list page and single domain view.
       */
      listPage: {
        type: Boolean,
        default: false,
      },
      lightImage: {
        type: String,
        default: emptyListLightBigImg,
      },
      darkImage: {
        type: String,
        default: emptyListDarkBigImg,
      },
      maxWidth: {
        type: String,
        default: "300px",
      },
    },
    data() {
      return {
        emptyListLightImg,
        emptyListDarkImg,
      };
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../@core/preset/preset/typography/index.scss";
  @import "../../@core/preset/preset/functions.scss";

  .empty-list {
    background-color: get-color("element-bg-100");
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    &__title {
      margin-top: 8px;
      @include heading-4();
      color: get-color("headline");
    }
    &__subtitle {
      margin-bottom: 24px;
      @include text-subtitle-2();
      color: get-color("subtitle");
    }

    &--big {
      padding: 154px 105px;
      height: 736px;

      .empty-list__title {
        margin-top: 0;
        margin-bottom: 12px;
        color: get-color("headline");
        font-size: 34px !important;
        line-height: 42px !important;
        font-weight: 700 !important;
      }
      .empty-list__subtitle {
        margin-bottom: 20px;
        @include text-subtitle-1();
        color: get-color("body");
      }
    }
  }
</style>
